const childRoutes = (prop) => [
    {
        path: 'course-module-management',
        name: prop + '.course_module_management',
        meta: { auth: true },
        component: () => import('../pages/course-module-management/List.vue')
    },
    {
        path: 'committee-management',
        name: prop + '.committee_management',
        meta: { auth: true },
        component: () => import('../pages/committee-management/List.vue')
    },
    {
        path: 'assign-course-trainer',
        name: prop + '.assign_course_trainer',
        meta: { auth: true },
        component: () => import('../pages/assign-course-trainer/List.vue')
    },
    {
        path: 'training-routine',
        name: prop + '.training_routine',
        meta: { auth: true },
        component: () => import('../pages/training-routine/List.vue')
    },
    {
        path: 'attendance-management',
        name: prop + '.attendance_management',
        meta: { auth: true },
        component: () => import('../pages/attendance-management/List.vue')
    },
    {
        path: 'training-material-info',
        name: prop + '.training_material_info',
        meta: { auth: true },
        component: () => import('../pages/training-material-info/List.vue')
    },
    {
        path: 'budget-management',
        name: prop + '.budget_management',
        meta: { auth: true },
        component: () => import('../pages/budget-management/List.vue')
    },
    {
        path: 'events-awards',
        name: prop + '.events_awards',
        meta: { auth: true },
        component: () => import('../pages/events-awards/List.vue')
    },
    {
        path: 'training-question',
        name: prop + '.training_question',
        meta: { auth: true },
        component: () => import('../pages/training-question/List.vue')
    }
]

const routes = [{
    path: '/training-e-learning-service/training-plan-management',
    name: 'training_e_learning_service.training_plan_management',
    component: () => import('@/layouts/TrainingElearningLayout.vue'),
    meta: { auth: true },
    children: childRoutes('training_e_learning_service.training_plan_management')
}]

export default routes
